import { TEntityDateblock } from "../models";
import { dedupeLinkedItemsById } from "./get-bid-package-linked-materials";

export type TBidPackageLinkedSubmittal = {
  id: string;
  number?: string;
  title?: string;
  auto_inc_value?: string | number;
  feature_type_id?: number;
  implicit?: boolean;
  governing_link?: boolean;
};

/** Submittals listed on the Bid Package Submittals tab, from `bid_package_submittals`. */
export function getBidPackageLinkedSubmittals(
  entity?: TEntityDateblock
): TBidPackageLinkedSubmittal[] {
  const links = (entity as any)?.bid_package_submittals as
    | Array<{
        governing_link?: boolean;
        target_feature_instance?: TBidPackageLinkedSubmittal;
      }>
    | undefined;

  return dedupeLinkedItemsById(
    (links ?? [])
      .filter((link) => link.target_feature_instance?.id)
      .map((link) => ({
        ...(link.target_feature_instance as TBidPackageLinkedSubmittal),
        governing_link: link.governing_link
      }))
  );
}
